import "../scss/base.scss";

export { createFooter } from "./entry-core";
